/**
 * Converts a given price in price-per-square-meter to price-per-square-foot
 *
 * @param {number} pricePerSqm - Price per square meter
 * @returns {number} - Price per square foot
 */
export default function convertPricePerSqmToSqft(pricePerSqm) {
  const conversionFactor = 10.7639;
  return (pricePerSqm / conversionFactor).toFixed(0);
}
